<script lang="ts" setup>
import { ModeEnum } from '@/store/modules/settings/types'

defineEmits(['set-list'])


withDefaults(defineProps<{
  isAutomationAllowed: boolean
  isNewCodingAllowed?: boolean
  isOptimizableAllowed?: boolean
  isDialysisAllowed?: boolean
  isAutomationEnabled: boolean
  selectedList: string
}>(), {
  isNewCodingAllowed: true,
  isOptimizableAllowed: true,
  isDialysisAllowed: false,
})
</script>

<template>
  <ul class="g-0 nav nav-tabs">
    <li
      v-if="isAutomationAllowed"
      v-tooltip="isAutomationEnabled ? null : 'Cette fonctionnalité a été désactivée par un administrateur'"
      class="nav-item col text-center home-list-tab"
    >
      <span
        :class="{ 'active': selectedList === ModeEnum.AUTOMATION, 'disabled': !isAutomationEnabled }"
        class="nav-link"
        @click="isAutomationEnabled ? $emit('set-list', ModeEnum.AUTOMATION) : null"
      >
        {{ $t('tab.automation') }}
      </span>
    </li>
    <li
      v-if="isNewCodingAllowed"
      class="nav-item col text-center home-list-tab"
    >
      <span
        :class="{ 'active': selectedList === ModeEnum.NEW_CODING }"
        class="nav-link"
        @click="$emit('set-list', ModeEnum.NEW_CODING)"
      >
        {{ $t('tab.new-coding') }}
      </span>
    </li>
    <li
      v-if="isOptimizableAllowed"
      class="nav-item col text-center home-list-tab"
    >
      <span
        :class="{ 'active': selectedList === ModeEnum.OPTIMIZABLE }"
        class="nav-link"
        @click="$emit('set-list', ModeEnum.OPTIMIZABLE)"
      >
        {{ $t('tab.optimizable') }}
      </span>
    </li>
    <li
      class="nav-item col text-center home-list-tab"
    >
      <span
        :class="{ 'active': selectedList === ModeEnum.QUALITY_STAYS }"
        class="nav-link"
        @click="$emit('set-list', ModeEnum.QUALITY_STAYS)"
      >
        {{ $t('tab.quality-stays') }}
      </span>
    </li>
    <li
      v-if="isDialysisAllowed"
      class="nav-item col text-center home-list-tab"
    >
      <span
        :class="{ 'active': selectedList === ModeEnum.DIALYSIS }"
        class="nav-link"
        @click="$emit('set-list', ModeEnum.DIALYSIS)"
      >
        {{ $t('tab.dialysis') }}
      </span>
    </li>
  </ul>
</template>
